import { render, staticRenderFns } from "./ShopFormComponent.vue?vue&type=template&id=b4d4e6e2&scoped=true&"
import script from "./ShopFormComponent.vue?vue&type=script&lang=js&"
export * from "./ShopFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShopFormComponent.vue?vue&type=style&index=0&id=b4d4e6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d4e6e2",
  null
  
)

export default component.exports